<i class="fa fa-bell" (click)="open(content)" container="body"></i>
<!-- モーダル -->
<ng-template #content let-modal>
  <div class="modal-body" (keydown)="EnterOnRegister($event)">
    <h3 class="modal-title">通知登録</h3>
    <input class="form-control" placeholder="JAVA専門" [(ngModel)]="name" />

    <h5 class="mt-3">通知方法:</h5>
    <div class="mt-3">
      slack:
      <div class="ml-5 btn-group btn-group-toggle" ngbRadioGroup name="radioBasic" [(ngModel)]="filter_enable">
        <label ngbButtonLabel class="btn-primary">
          <input ngbButton type="radio" [value]="false"> OFF
        </label>
        <label ngbButtonLabel class="btn-primary">
          <input ngbButton type="radio" [value]="true"> ON
        </label>
      </div>
    </div>


  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary-dark" [ngClass]="{'btn-disabled': !(name?.length > 0)}"
      (click)="registerNotification()" [disabled]="!(name?.length > 0)">
      登録
    </button>
  </div>
</ng-template>